import { isNil, isEmpty, clone, map, filter } from "ramda";

export default function cleanEmptyImages(value) {
  const newValue = clone(value);
  newValue.garment = map((g) => cleanGarment(g), value.garment);
  return newValue;
}

const cleanGarment = (garment) => {
  const newGarment = clone(garment);
  newGarment.garment.arrangement_group = map((g) => cleanArrangementGroup(g), garment.garment.arrangement_group);
  return newGarment;
};

const cleanArrangementGroup = (arrangementGroup) => {
  const newArrangementGroup = clone(arrangementGroup);
  newArrangementGroup.arrangement_group.arrangement_images = filter(
    (v) => v !== null,
    map((g) => cleanArrangementImages(g), arrangementGroup.arrangement_group.arrangement_images)
  );
  return newArrangementGroup;
};

const cleanArrangementImages = (arrangementImages) => {
  if (isNil(arrangementImages?.arrangement_images?.value) || isEmpty(arrangementImages?.arrangement_images?.value)) {
    return null;
  }
  return arrangementImages;
};
